export default {
    namespaced: true
};
